<template>
  <div>
    <v-dialog
      max-width="350px"
      max-height="350px"
      v-model="show"
      scrollable
    >
      <v-card>
        <v-card-title>
          Status
          <v-spacer></v-spacer>
          <v-btn
            icon
            @click.prevent="show = false"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="pt-3">
          <v-row justify="center">
            <v-col cols="12" md="12" lg="12">
              <h3>Status Name</h3>
              <v-text-field
                v-model="currentAssetsStatus.Status"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn small color="primary" @click.prevent="saveAssetsStatus" :disabled="disableSave">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>

export default {
  name: 'AssetsStatusEditor',
  props: {
    value: {
      required: false
    },
    currentAssetsStatus: {
      required: false,
      default: null
    },
    addMode: {
      required: false,
      default: false
    },
    assets_statuses: {
      required: false,
      default: null
    }
  },
  data () {
    return {
      disableSave: false
    }
  },
  computed: {
    show: {
      get () {
        return this.value
      },
      set (value) {
        this.$emit('input', value)
      }
    },
    user () {
      return this.$store.getters.getUser
    }
  },
  mounted () {
  },
  methods: {
    saveAssetsStatus () {
      this.disableSave = true
      if (this.addMode) {
        const body = {
          Status_Name: this.currentAssetsStatus.Status
        }
        this.axios.post('/api/asset_status', body, {
          headers: {
            Authorization: 'Bearer ' + this.user.token
          }
        }).then(res => {
          this.disableSave = false
          this.show = false
          this.assets_statuses.push(res.data[0])
          this.$store.dispatch('setSuccess', { successMsg: 'Status succesefully added' })
        }).catch(error => {
          this.disableSave = false
          this.$store.dispatch('setError', { errorMsg: error.message + ' - ' + error.response.data })
        })
      } else {
        this.axios.put(`/api/asset_status/${this.currentAssetsStatus.Status_ID}`, this.currentAssetsStatus, {
          headers: {
            Authorization: 'Bearer ' + this.user.token
          }
        }).then(res => {
          for (let i = 0; i < this.assets_statuses.length; i++) {
            if (this.assets_statuses[i].Status_ID === this.currentAssetsStatus.Status_ID) {
              this.assets_statuses[i].Status = this.currentAssetsStatus.Status
              break
            }
          }
          this.disableSave = false
          this.show = false
          this.$store.dispatch('setSuccess', { successMsg: 'Status succesefully updated' })
        }).catch(error => {
          this.disableSave = false
          this.$store.dispatch('setError', { errorMsg: error.message + ' - ' + error.response.data })
        })
      }
    }
  }
}
</script>
